import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Loading from "../components/Loading";
import SingleProduct from "../components/product/SingleProduct";
import { getProducts } from "../redux/features/ProductSlice";

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const SearchedProducts = () => {
  const dispatch = useDispatch();
  const products = useSelector((state) => state.mainproduct.searchedProducts);
  const loading = useSelector((state) => state.mainproduct.isLoading);
  const query = useQuery();
  const searchQuery = query.get("q") || "";

  useEffect(() => {
    const filters = { name: { $like: searchQuery } };
    searchQuery && dispatch(getProducts({ limit: 50, search: 1, filters }));
  }, [dispatch, searchQuery]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <div className="container overflow-hidden bg-white md:pb-14">
      {loading ? (
        <div className="flex justify-center h-[calc(100vh-4rem)] items-center">
          <Loading />
        </div>
      ) : products?.length === 0 ? (
        <div className="px-4 py-12 text-center md:pt-24 md:px-0">
          <img
            src="/images/nodataimg.png"
            className="sm:w-[60%] lg:w-[40%] mx-auto pb-8"
            alt=""
          />
          <h2 className="text-3xl font-semibold uppercase">
            opps no result for search product "{searchQuery}"
          </h2>
          <p>Don&apos;t give up! Check the spelling or try something else.</p>
        </div>
      ) : (
        <div>
          <h2 className="py-8 pt-10 text-2xl italic font-semibold uppercase">
            Search results of "{searchQuery}"
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-5">
            {products?.map((product, index) => (
              <SingleProduct key={index} product={product} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchedProducts;
